import ReUseableHeader from "../ReUseableHeader/ReUseableHeader";
import React from "react";
import SundarTeamImage from "../../assets/Sundar-Team.jpg";
import OutsideSundarImage from "../../assets/OutsideSundar.png";
import CoreValuesSundar from "../../assets/CoreValues.png";
import card1 from "../../assets/Mini-card1.png";
import card2 from "../../assets/MiniCard2.png";
import card3 from "../../assets/Mini-card3.png";
import "./AboutUs.css";
import Footer from "../dashBoard/footer/Footer";

export default function About() {
  return (
    <>
      <ReUseableHeader
        head="About Us"
        subHead1="Home"
        subHead2="About Us"
      ></ReUseableHeader>
      <div className="container mt-6">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-lg-6 col-sm-10 col-10 col align-self-center">
            <h1 className="fw-bold col-6 wrap">Who we are</h1>
            <p className="col-11 text-muted">
              Sundar Industrial Estate comprising of 1750 acres of land was
              inaugurated in Feb, 2007 and is a vision turned into reality. It
              is the first project assigned to PIE & was envisioned to be an
              ‘island of facilitation in the sea of harassment’ for prospective
              industrialists. The objective was to develop an industrial estate
              where issues of industrialists are handled and problems solved
              through ‘One Window’ operation. There are more than 566 factories
              in production (as of June 2022) and more than 29 factories are
              near to production within the next year.
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-lg-6 col-sm-10 col-10 col align-self-center p-6">
            <img src={SundarTeamImage} className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container mt-6 mb-4">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-lg-6 col-sm-10 col-10 col align-self-center p-6">
            <img src={OutsideSundarImage} className=" imgStyleOutdor" />
          </div>
          <div className="col-lg-6 col-md-6 col-lg-6 col-sm-10 col-10 col align-self-center">
            <h1 className="fw-bold col-6 wrap">Our mission</h1>
            <p className="col-11 text-muted">
              BOMSIE Mission is to provide “Excellence in Industrial Estate
              Services” to all of our Residents by conducting all of our
              business with the highest levels of professionalism, honesty and
              integrity.
            </p>
          </div>
        </div>
      </div>
      {/* Ensome in numbers */}
      <div className="bgNewColor py">
        <div className="container p-0 pt-2">
          <div className="d-flex align-items-start justify-content-center">
            <h1 className="row headerSize">Ensome in numbers</h1>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 py-5">
            <div className="col d-flex align-items-start justify-content-center">
              <div className="d-flex justify-content-start sizecenter">
                <div className="ml">
                  <h1 className="mb-1 textColor">1830+</h1>
                  <p className="text-muted">Project executed</p>
                </div>
              </div>
            </div>
            <div className="col d-flex align-items-start justify-content-center">
              <div className="d-flex justify-content-start sizecenter">
                <div className="ml">
                  <h1 className="mb-1 textColor">220</h1>
                  <p className="text-muted">Data analytics</p>
                </div>
              </div>
            </div>
            <div className="col d-flex align-items-start justify-content-center">
              <div className="d-flex justify-content-start sizecenter">
                <div className="ml">
                  <h1 className="mb-1 textColor">390</h1>
                  <p className="text-muted">Data management</p>
                </div>
              </div>
            </div>
            <div className="col d-flex align-items-start justify-content-center">
              <div className="d-flex justify-content-start sizecenter">
                <div className="ml">
                  <h1 className="mb-1 textColor">834+</h1>
                  <p className="text-muted">Satisfied customers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* < 3 Cards */}
      <div className="container">
        <div className="row py-5 d-flex justify-content-center cant my-6">
          <div
            style={{ backgroundImage: `url(${card1})` }}
            className="row col-lg-3 col-md-3 col-sm-4 mx-3 CommonCard"
          >
            <h3 className="h3line">Service</h3>
            <span>
              <ul>
                <li>Standardized processes.</li>
                <li>Fast track data collection , analysis,</li>
                <li>reporting and decision making.</li>
              </ul>
            </span>
          </div>

          <div
            style={{ backgroundImage: `url(${card2})` }}
            className="row col-lg-3 col-md-3 col-sm-4 mx-3 CommonCard"
          >
            <h3 className="h3line">Transparency</h3>
            <span>
              <ul>
                <li>Standardized processes.</li>
                <li>Fast track data collection , analysis,</li>
                <li>reporting and decision making.</li>
              </ul>
            </span>
          </div>

          <div
            style={{ backgroundImage: `url(${card3})` }}
            className="row col-lg-3 col-md-3 col-sm-4 mx-3 CommonCard"
          >
            <h3 className="h3line">Efficiency</h3>
            <span>
              <ul>
                <li>Clarity of roles and deliverables</li>
                <li>Smart team work</li>
              </ul>
            </span>
          </div>
        </div>
      </div>
      {/* Image */}

      <div className="imgsection">
        <img src={CoreValuesSundar} className="CoreImg" alt="..." />
      </div>
      <Footer />
    </>
  );
}
